import EditSuccessPostDoc from "./EditSuccessPostDoc";
export default EditSuccessPostDoc;
